// Note: Install @reduxjs/toolkit and react-redux 
// npm install @reduxjs/toolkit react-redux

import { configureStore } from '@reduxjs/toolkit';
import cvUploadReducer from './features/cvUpload/cvUploadSlice';

export const store = configureStore({
  reducer: {
    cvUpload: cvUploadReducer,
    // Add other reducers here as your app grows
  },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch; 